/* global axios */
import ApiClient from './ApiClient';

class PipelinesApiClient extends ApiClient {
  constructor() {
    super('pipelines', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(pipelineData) {
    return axios.post(this.url, { pipeline: pipelineData });
  }

  update(id, pipelineData) {
    return axios.patch(`${this.url}/${id}`, { pipeline: pipelineData });
  }

  destroy(id, params = {}) {
    return axios.delete(`${this.url}/${id}`, { params });
  }

  getStages(pipelineId) {
    return axios.get(`${this.url}/${pipelineId}/pipeline_stages`);
  }

  createStage(pipelineId, stageData) {
    return axios.post(`${this.url}/${pipelineId}/pipeline_stages`, {
      pipeline_stage: stageData,
    });
  }

  updateStage(pipelineId, stageId, stageData) {
    return axios.patch(`${this.url}/${pipelineId}/pipeline_stages/${stageId}`, {
      pipeline_stage: stageData,
    });
  }

  destroyStage(pipelineId, stageId) {
    return axios.delete(`${this.url}/${pipelineId}/pipeline_stages/${stageId}`);
  }
}

export default new PipelinesApiClient();
